import { useCallback, useEffect, useMemo, useReducer } from 'react'
import { SUBJECTS, QUESTIONS } from '../../shared/constants/faq'
import normalize from '../../shared/helpers/normalize'

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'changeFilter':
      const filters = state.filters.includes(payload)
        ? state.filters.filter(filter => filter !== payload)
        : [...state.filters, payload]

      return {
        ...state,
        filters,
        questions:
          filters.length === 0
            ? QUESTIONS
            : QUESTIONS.filter(question => filters.includes(question.subject))
      }
    case 'homeFaq':
      const homeFilters = ['Aplicativo', 'Dúvidas Gerais']
      return {
        ...state,
        filters: homeFilters,
        questions: QUESTIONS.filter(question => homeFilters.includes(question.subject))
      }
    case 'setSelectedQuestion':
      return {
        ...state,
        selectedQuestion: payload
      }
    case 'updateSearch':
      return {
        ...state,
        search: payload
      }
    case 'searchQuestions':
      const debouncedSearch = normalize(payload.toLowerCase())
      const getAnswer = (answer) => Array.isArray(answer) ? answer[0] : answer
      return {
        ...state,
        filters: [],
        debouncedSearch,
        questions: QUESTIONS.filter(
          ({ text, subject, answer }, i) =>
            normalize(text.toLowerCase()).includes(debouncedSearch) ||
            normalize(subject.toLowerCase()).includes(debouncedSearch) ||
            normalize(getAnswer(answer).toLowerCase()).includes(debouncedSearch)
        )
      }
    default:
      return state
  }
}

const initialState = {
  filters: [],
  subjects: SUBJECTS,
  questions: QUESTIONS,
  search: '',
  debouncedSearch: '',
  selectedQuestion: undefined
}

const useBehavior = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const handleChangeFilter = useCallback(
    payload => {
      dispatch({ type: 'changeFilter', payload })
    },
    [dispatch]
  )

  const handleHomeFaq = useCallback(
    payload => {
      dispatch({ type: 'homeFaq', payload })
    },
    [dispatch]
  )

  const handleClickQuestion = useCallback(
    payload => {
      dispatch({ type: 'setSelectedQuestion', payload })
    },
    [dispatch]
  )

  const handleCloseDialog = useCallback(() => {
    handleClickQuestion()
  }, [handleClickQuestion])

  const updateSearch = useCallback(
    event => {
      dispatch({ type: 'updateSearch', payload: event.currentTarget.value })
    },
    [dispatch]
  )

  const isModalOpen = useMemo(() => Boolean(state.selectedQuestion), [
    state.selectedQuestion
  ])

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch({ type: 'searchQuestions', payload: state.search })
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [state.search, dispatch])

  return {
    ...state,
    isModalOpen,
    handleChangeFilter,
    handleClickQuestion,
    handleCloseDialog,
    handleHomeFaq,
    updateSearch
  }
}

export default useBehavior
